<template>
  <div class="about">
    <div class="py-5 bg-white">
      <div class="indexAbout py-lg-4">
        <div class="container-fluid px-3 px-md-2">
          <div class="row row-cols-1 row-cols-md-2 gx-3 gy-4 g-lg-2">
            <div class="col">
              <div class="lh-lg text">
                <h2 class="mb-4 mb-lg-5 fw-bold text-uppercase text-dark">Profile</h2>
                <div class="position-relative" v-html="profile.content"></div>
              </div>
            </div>
            <div class="col">
              <div class="pic mt-2" v-for="(item,index) in profile.picture" :key="index">
                <img :src="item" class="w-100 h-100 object-fit-cover">
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="people py-5 bgA">
      <div class="container-lg py-lg-4 px-3">
        <h2 class="mb-4 mb-lg-5 fw-bold text-uppercase text-dark">People</h2>
        <div class="row row-cols-1 row-cols-md-2 gx-3 gy-4 gx-lg-5">
          <div class="col" v-for="(item,index) in people" :key="index">
            <router-link :to='"/people/" + item.id' target="_blank" class="position-relative">
                <div class="pic">
                  <img :src="item.picture" class="w-100 h-100 object-fit-cover">
                </div>
                <div class="text text-center mt-3 p-lg-3">
                  <h4 class="mb-0">{{item.name}}</h4>
                  <p class="mt-1">{{item.title}}</p>
                </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from '@/axios-auth'

export default {
  name: 'About',
  data () {
    return {
      profile:'',
      people:[]
    
    }
  },
  created(){
    axios.get('/about.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.people = response.data.people
            this.profile = response.data.profile
          }
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .indexAbout .text{ color: #666;}

  .indexAbout .pic:first-child{ margin-top: 0 !important;}
  .indexAbout .pic{ height: 250px;}
  .people a{ display: block;}
  .people .text{ color: #000;}
  .people .text p{ color: #999;}


  @media (min-width: 576px) {
  
  }

  @media (min-width: 768px) {
    .people .pic{ height: 500px;}
  }

  @media (min-width: 992px) {
    .indexAbout .text{ padding-left:calc((100vw - 960px) / 2 + .5rem); padding-right: 5%; position: sticky; left: 0; top: 110px;}
    .indexAbout .pic{ height: 350px;}
    
    .people .pic{ height: 520px;}
    .people .pic::after{ content: ''; position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-color: rgba(255, 255, 255, .9); opacity: 0; transition: all .5s;}
    .people .text{position: absolute; left: 0; right: 0; top: 0; bottom: 0; transform: translateY(50px); display: flex; flex-direction: column; justify-content: center; align-items: center; opacity: 0; transition: all .3s;}
    .people .text h4{ font-size: 2.5vw;}
    .people a:hover .pic::after{ opacity: 1;}
    .people a:hover .text{ opacity: 1; transform: translateY(0);}

  }

  @media (min-width: 1200px) {
    .indexAbout .text{ padding-left:calc((100vw - 1140px) / 2 + .5rem);}
    .people .pic{ height: 600px;}
  }

  @media (min-width: 1400px) {
    .indexAbout .text{ padding-left:calc((100vw - 1320px) / 2 + .5rem);}
    .indexAbout .pic{ height: 500px;}

    .people .pic{ height: 700px;}

  }
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue